export interface ILanguageData {
    value: string;
    label: string;
  }
  
  export const systemLanguage: Array<ILanguageData> = [
    {
      value: "de",
      label: "Deutsch",
    },
    {
      value: "en",
      label: "English",
    },
  ];
  
  
  